import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { loginWithToken } from '@actions/authentication';

export class LoginWithToken extends PureComponent {
  componentDidMount() {
    this.props.loginWithToken(this.props.match.params);
  }

  render = () => null;
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  loginWithToken,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginWithToken);



// WEBPACK FOOTER //
// ./components/pages/LoginWithToken.js